import { HttpService } from '../../../http.service';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { State } from '../../../model/state';
import { County } from '../../../model/county';
import { Operator } from '../../../model/operator';
import { Purchaser } from '../../../model/purchaser';
import { Product } from '../../../model/product';
import { Well } from '../../../model/well';
import { Bank } from '../../../model/bank';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HttpLookupService {
  private apiUrl = environment.apiUrl;

  constructor(private httpService: HttpService) { }

  getStates(): Observable<State[]> {
    const url = `/getStates`;
    return this.httpService.get(url, false);
  }

  getAllStatesCounties(): Observable<State[]> {
    const url = `/getAllStatesCounties`;
    return this.httpService.get(url, false);
  }

  getCounties(stateName: string): Observable<County[]> {
    const url = `/getCounties/${stateName}`;
    return this.httpService.get(url, false);
  }

  getOperators(): Observable<Operator[]> {
    const url = `/getOperators`;
    return this.httpService.get(url, false);
  }

  getOperator(id: number): Observable<Operator> {
    const url = `/getOperator/${id}`;
    return this.httpService.get(url, false);
  }

  getMroOperators(): Observable<Operator[]> {
    const url = `/getMroOperators`;
    return this.httpService.get(url, false);
  }

  getPurchasers(): Observable<Purchaser[]> {
    const url = `/getPurchasers`;
    return this.httpService.get(url, false);
  }

  getProducts(): Observable<Product[]> {
    const url = `/getProducts`;
    return this.httpService.get(url, false);
  }

  getWells(): Observable<Well[]> {
    const url = `/getWells`;
    return this.httpService.get(url, false);
  }

  getBanks(): Observable<Bank[]> {
    const url = `/getBanks`;
    return this.httpService.get(url, false);
  }

  getInterestTypes(): Observable<string[]> {
    const url = `/getInterestTypes`;
    return this.httpService.get(url, false);
  }

  // getDivisionOrderInterestTypes(): Observable<DivisionOrderInterestType[]> {
  //   const url = `/getDivisionOrderInterestTypes`;
  //   return this.httpService.get(url, false);
  // }


  private handleError(error: HttpErrorResponse) {
    console.error('An error occurred:', error);
    return throwError('Something went wrong. Please try again later.');
  }
}
